const SendIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 16V10L8 8L0 6V0L19 8L0 16Z" fill="currentColor" />
    </svg>
  )
}

export default SendIcon
